import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { FeatureIdEnum } from '../enums/feature-id.enum'

export const ROUTER_CONSTS = {
  routes: {
    login: 'login',
    logout: 'logout',
    root: 'root',
    home: 'home',
    [DomainEnum.SEARCH]: DomainEnum.SEARCH,
    [DomainEnum.BROWSE]: DomainEnum.BROWSE,
    [FeatureIdEnum.HIGHLIGHTS]: 'highlights',
    [FeatureIdEnum.INSIGHTS]: {
      [DomainEnum.BROWSE]: 'browseInsights',
    },
    [FeatureIdEnum.OVERALL]: {
      [DomainEnum.SEARCH]: 'searchOverall',
      [DomainEnum.BROWSE]: 'browseOverall',
    },
    [FeatureIdEnum.QUERIES]: 'queries',
    [FeatureIdEnum.NOW]: 'now',
    [FeatureIdEnum.CONVERSATIONAL]: 'conversational',
    [FeatureIdEnum.SEMANTICS]: 'semantics',
    [FeatureIdEnum.ORIGINS]: 'origins',
    [FeatureIdEnum.KEYWORDS]: 'keywords',
    [FeatureIdEnum.CATEGORIES]: 'categories',
    [FeatureIdEnum.RELATED_PROMPTS_ANALYTICS]: 'relatedPromptsAnalytics',
    [FeatureIdEnum.TOOL_REPORTING]: 'toolReporting',
    [FeatureIdEnum.PLAY]: {
      [DomainEnum.BROWSE]: 'browsePlay',
    },
    [FeatureIdEnum.EQUALIZE]: {
      list: 'equalize',
      create: 'createEqualize',
      update: 'updateEqualize',
    },
    [FeatureIdEnum.SYNONYM]: {
      list: 'synonyms',
      create: 'createSynonym',
      update: 'updateSynonym',
    },
    [FeatureIdEnum.BLACKLIST]: {
      list: 'blacklist',
      create: 'createBlacklist',
      update: 'updateBlacklist',
    },
    [FeatureIdEnum.PROMOTION]: {
      list: 'promotions',
      create: 'createPromotion',
      update: 'updatePromotion',
    },
    [FeatureIdEnum.REDIRECTION]: {
      list: 'redirections',
      create: 'createRedirection',
      update: 'updateRedirection',
    },
    [FeatureIdEnum.CONFIGURATION]: {
      [DomainEnum.SEARCH]: {
        list: 'searchConfigurations',
        create: 'createSearchConfiguration',
        update: 'updateSearchConfiguration',
      },
      [DomainEnum.BROWSE]: {
        root: 'browseConfigurations',
        attributes: 'browseConfigurationsAttributes',
        list: 'browseConfigurationsList',
        create: 'createBrowseConfiguration',
        update: 'updateBrowseConfiguration',
      },
    },
    [FeatureIdEnum.RELATED_TAGS]: {
      list: 'relatedTags',
      create: 'createRelatedTags',
      update: 'updateRelatedTags',
    },
    [FeatureIdEnum.NEXT_QUERIES]: {
      list: 'nextQueries',
      create: 'createNextQueries',
      update: 'updateNextQueries',
    },
    [FeatureIdEnum.RELATED_PROMPTS]: {
      landing: 'relatedPrompts',
      preview: 'previewRelatedPrompts',
      overview: 'overviewRelatedPrompts',
      create: 'createRelatedPrompts',
      update: 'updateRelatedPrompts',
    },
    [FeatureIdEnum.EXPLAIN]: {
      landing: 'landing',
      search: 'explainSearch',
      queryAnalysis: 'explainQueryAnalysis',
      productAnalysis: 'explainProductAnalysis',
    },
    [FeatureIdEnum.FACETS]: {
      list: 'facets',
      create: 'createFacets',
      update: 'updateFacets',
    },
    [FeatureIdEnum.AUDIT]: 'audit',
    [FeatureIdEnum.INSTANCE_MANAGEMENT]: {
      root: 'management',
      service: 'service',
      search: 'searchService',
      index: 'indexService',
    },
    [FeatureIdEnum.INDEX]: 'index',
    [FeatureIdEnum.USER_ROLE_MANAGEMENT]: 'userRoleManagement',
    [FeatureIdEnum.ACCOUNT]: 'account',
    pageNotFound: 'pageNotFound',
  },
  params: {
    instanceId: 'instanceId',
    attribute: {
      name: 'attributeName',
      value: 'attributeValue',
    },
    id: 'id',
    service: 'service',
    child: 'child',
  },
  query: {
    redirect: 'redirect',
    filterPrefix: 'filter.',
    query: 'q',
    facet: 'facet',
    fullscreen: 'fullscreen',
    strictMatching: 'strictMatching',
  },
}
